// 服务端日志过滤配置
export const ServerLoggerFilterConfig = new Map<string, boolean>([
    [`redis.ts|jsonGet`, false],
    [`redis.ts|jsonSet`, false],
]);

// 客户端日志过滤配置
export const EdgeLoggerFilterConfig = new Map<string, boolean>([
    [`proxy.ts|proxy`, false]
]);